import React from "react";
import TutorialPopup from "../help/TutorialPopup";
import { useSelector } from "react-redux";
import { currencyFormat } from "../../utils/Utils";

const SpotOverview = (props)=>{

    const {data} = props
    const {
        t,
        timeframe,
        
    } = data

    const {
        trading_volume,
        portfolio_value,
        portfolio_changed,
      } = useSelector((state) => state.portfolio);
    const changeUp = portfolio_changed && portfolio_changed > 0;
    const currency = useSelector((state) => state.settings.currency);

    return(
        <>
        <div className="col-xl-3 col-lg-2 col-md-6 col-sm-6 v-pad">
            <p className="small-text">{t("portf-val")}</p>
            <h2>
            {currencyFormat(portfolio_value && portfolio_value.toFixed(2) || "0")} {currency && currency.name}
            </h2>
        </div>
        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 v-pad">
            <p className="small-text">{timeframe} Change</p>
            <h2 className={changeUp ? "upward-change" : "downward-change"}>
            {changeUp?<i className="fas fa-arrow-up"></i>:<i className="fas fa-arrow-down"></i>}
            {" "}
            {portfolio_changed && portfolio_changed.toFixed(2) || "0"}%
            </h2>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 v-pad">
            <p className="small-text">
            {timeframe} {t("t-volume")}{" "}<TutorialPopup content="Cumulative" />
            </p>
            <h2>
            {currencyFormat(trading_volume && trading_volume.toFixed(2) || "0")} {currency && currency.name}
            </h2>
        </div>
        </>
    )
}

export default SpotOverview;